import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";
import { Reseller } from "../../resellers/shared";

@Component({
  selector: "product-where-to-buy-form",
  templateUrl: "./product-where-to-buy-form.component.html",
})
export class ProductWhereToBuyFormComponent {
  @Input() form: FormGroup;
  @Input() resellers: Array<Reseller> = [];

  constructor(public ft: FormToolsService) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-where-to-buy-form/product-where-to-buy-form.component.ts